import React, { Component } from 'react';
import moment from 'moment';
import HeatMap from 'components/Charts/HeatMap.react';

import styles from '../Metrics.scss';

export default class Requests extends Component {
  constructor(props) {
    super(props);

    this.section = 'Metrics';
    this.subsection = 'Requests';

    this.labels = Array(10).fill(null).map((_, i) => new Date(`2018-07-${i < 10 ? `0${i}` : i}T00:00:00`).getTime());
    this.values1 = Array(10).fill(null).map((_, i) => i);
    this.values2 = Array(10).fill(null).map((_, i) => i + 3);

    this.labels.shift()
    this.values1.shift()
    this.values2.shift()

    this.state = {
      loading: true,
      newData: {
        labels: this.labels,
        datasets: [
          {
            name: "Cloud Requests",
            values: this.values1,
          },
          {
            name: "Api Requests",
            values: this.values2,
          }
        ]
      }
    };
  }

  render() {
    return (
      <HeatMap
        title={this.props.title}
        desc={this.props.desc}
        tooltip={this.props.tooltip}
        heigth={160}
        type='heatmap'
        dataFormat={this.props.dataFormat}
        data={{
          dataPoints: this.props.data
        }}
        countLabel={this.props.unit}
        colors={['#ebedf0', '#c0ddf9', '#73b3f3', '#3886e1', '#17459e']}
        isNavigable
        valuesOverPoints />
    );
  }
}
